<tec-tile [title]="'MASTER.STATUS.IN_PROGRESS' | translate">
	@if (rolePermissions.canViewPanelDeveloperCurl() || content?.length > 0) {
		<ng-container actions>
			@if (rolePermissions.canViewPanelDeveloperCurl()) {
				<tec-button-icon
					icon="icon-code-brackets"
					type="default"
					size="sm"
					(clickEvent)="openCurlModal()"
				/>
			}
			@if (content?.length > 0) {
				<tec-button type="outline" icon="icon-arrow-right" (clickEvent)="goToInProgressProcesses($event)">{{
					'BUTTON.SEE_ALL' | translate
				}}</tec-button>
			}
		</ng-container>
	}
	<tec-table [rows]="content" [config]="config" (rowEvent)="tableRow($event)" />
</tec-tile>

@if (curlModalOpen()) {
	<app-modal-curl-request
		[titleKey]="'PANEL.CURL_MODAL.TITLE_IN_PROGRESS'"
		[curlText]="getInProgressCurl()"
		(closeEvent)="closeCurlModal()"
	/>
}
